import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoginComponent } from 'shared/components/login/login.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LogInWithGoogleComponent } from 'shared/components/log-in-with-google/log-in-with-google.component';
import { LogInWithAppleComponent } from 'shared/components/log-in-with-apple/log-in-with-apple.component';

@Component({
  standalone: true,
  selector: 'app-auth',
  imports: [CommonModule, RouterLink, LoginComponent, MatButtonModule, MatIconModule, LogInWithGoogleComponent, LogInWithAppleComponent],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent  {

}
